var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"shopping-cart-icon"},_vm.$listeners),[_c('r-icon',{attrs:{"name":"shopping_cart","size":"18px"}}),(_vm.indicator)?_c('dot-indicator',{staticClass:"red-indicator",attrs:{"blink":_vm.blink}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }